import { useEffect, useState } from 'react';


export const useBusinessTypes = () => {
    const apiURL = "/wp-json/fac/v1/get-business-types";

    const [loadState, setLoadState ] = useState( true );
    const [types, setTypes] = useState( [] );

    // run once, no need to watch
    useEffect(() => {
      fetch( apiURL, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          'Accept': 'application/json'
        }
      })
    .then(res => res.json())
    .catch(console.error)
    .then((data) => {
      setTypes( data );
    })
    .then(() => {
      setLoadState( false );
    })
  }, [])

  // everything uses this hook has this state； no need to set the state outside of this hook
  // return 2 states we need in an []； may refactor loadState later
  return [ types, loadState ]
}
